module.exports = {
      id: "icon-social-whatsapp-share-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-social-whatsapp-share",
      toString: function () {
        return this.url;
      }
    }